module.exports = __webpack_public_path__ + "static/media/img-article-popular.fc29a4cd.png";